<script>
import {sections} from "../stores"
import { fade } from "svelte/transition";
import { onDestroy } from "svelte";
export let hideControls
export let index;

let unsub = $sections;

function removeSection() {
    $sections.splice(index, 1);
    hideControls();
}

onDestroy(()=>{
    $sections = unsub;
})
</script>
<div class="df-section-controls-controlpanel shadow" in:fade>
<div class="text-right"><i class='bx bx-x' on:click={hideControls}></i></div>
<div class="menu-item shadow-sm">
    Change background
</div>
<div class="menu-item shadow-sm text-danger" on:click="{removeSection}">
    Remove Section
</div>
</div>

<style>
    .df-section-controls-controlpanel {
        position: absolute;
        background: #ffffff;
        top: 20px;
        right: 20px;
        padding: 10px 20px;
        border-radius: 7px;
        width: 300px;
        z-index: 999;
    }
    .menu-item {
        padding: 10px 10px;
        border-radius:4px;
        cursor: pointer;
    }
</style>